"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _TableLoadingLabel = _interopRequireDefault(require("./TableLoadingLabel"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    tableRow: {
      '&:last-child > $tableCell': {
        borderBottom: 'none'
      },
      height: 55
    },
    tableCell: {},
    checkboxCell: {
      padding: spacing(1, 0)
    },
    checkbox: {
      padding: 0,
      '&.Mui-checked': {
        color: palette.primary.common
      }
    }
  };
});

var TableDataRow = function TableDataRow(_ref2) {
  var data = _ref2.data,
      columns = _ref2.columns,
      isLoading = _ref2.isLoading,
      _ref2$isSelectable = _ref2.isSelectable,
      isSelectable = _ref2$isSelectable === void 0 ? false : _ref2$isSelectable,
      _ref2$isSelected = _ref2.isSelected,
      isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected,
      _ref2$onToggleSelecte = _ref2.onToggleSelected,
      onToggleSelected = _ref2$onToggleSelecte === void 0 ? function () {
    return undefined;
  } : _ref2$onToggleSelecte,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {
    return undefined;
  } : _ref2$onClick,
      _ref2$onMouseEnter = _ref2.onMouseEnter,
      onMouseEnter = _ref2$onMouseEnter === void 0 ? function () {
    return undefined;
  } : _ref2$onMouseEnter,
      _ref2$onMouseLeave = _ref2.onMouseLeave,
      onMouseLeave = _ref2$onMouseLeave === void 0 ? function () {
    return undefined;
  } : _ref2$onMouseLeave,
      className = _ref2.className;
  var classes = useStyles();
  var handleToggleSelected = (0, _react.useCallback)(function () {
    if (!isLoading) {
      data && onToggleSelected(data);
    }
  }, [onToggleSelected, data, isLoading]);
  var handleClick = (0, _react.useCallback)(function () {
    data && onClick(data);
  }, [onClick, data]);
  var handleMouseEnter = (0, _react.useCallback)(function () {
    return data && onMouseEnter(data);
  }, [data, onMouseEnter]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    return data && onMouseLeave(data);
  }, [data, onMouseLeave]);

  var renderRow = function renderRow(id, render) {
    return data ? function () {
      return render ? render(data) : data[id];
    } : function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
    selected: isSelected,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    className: (0, _classnames["default"])(classes.tableRow, className)
  }, isSelectable && /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    className: (0, _classnames["default"])(classes.tableCell, classes.checkboxCell)
  }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
    color: "secondary",
    checked: isSelected,
    onChange: handleToggleSelected,
    className: classes.checkbox
  })), columns.map(function (_ref3, i) {
    var id = _ref3.id,
        align = _ref3.align,
        isEmpty = _ref3.isEmpty,
        render = _ref3.render;
    return isEmpty ? /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      className: classes.tableCell,
      key: "empty_".concat(String(i))
    }) : /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      align: align,
      className: classes.tableCell,
      key: id
    }, /*#__PURE__*/_react["default"].createElement(_TableLoadingLabel["default"], {
      isLoading: isLoading,
      align: align === 'left' || align === 'right' ? align : undefined,
      render: renderRow(id, render)
    }));
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(TableDataRow);

exports["default"] = _default;